module.exports = {render: function () {with(this){return _c('svg',{staticClass:"logo-back",attrs:{"id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 34","width":"46","height":"34"}},[_c('g',{attrs:{"id":"Group_101","transform":"translate(-16697.107 -13626.546)"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M16726.9 13628.3H16731.3c5.5 0 9.9 4.5 9.8 9.9v.1c0 5.5-4.5 9.9-9.9 9.8h-31.3"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_48","d":"M16711 13659.3l-11.1-11.1 11.1-11.1"}})])])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-back.svg
// module id = kE1a
// module chunks = 0